import React              from 'react';
import { reduxForm }      from 'redux-form';
import { useTranslation } from 'react-i18next';
import i18n               from 'i18next';

import RenderButton            from '../../buttons/base/RenderButton';
import { RenderEmailField }    from '../../fields/redux/RenderEmailField';
import { RenderPasswordField } from '../../fields/redux/RenderPasswordField';
import { RenderCheckboxField } from '../../fields/redux/RenderCheckboxField';

import { useUser } from '../../../providers/user';

const AuthForm = (props) => {
  const {
          dispatch,
          email,
          isActive,
          handleSubmit,
          submitForm,
          changeTab,
        }     = props;
  const { t } = useTranslation();

  const { getReactivationLink } = useUser();

  const handleClick = (event, email) => {
    event.preventDefault();
    event.stopPropagation();

    getReactivationLink(email);
  };

  return (
    <form
      name={'AuthForm'}
      className={'AuthForm'}
      noValidate={true}
      method={'post'}
      onSubmit={event => submitForm(event, handleSubmit)}
    >
      <fieldset>
        <RenderEmailField name={'login'} label={t('client_set_email_login_phone')} />
        <RenderPasswordField name={'password'} label={t('client_set_password')} />
      </fieldset>
      <div>
        <RenderCheckboxField name={'_remember_me'} label={t('client_rememberMe')} />
        <span
          className={'forgot'}
          onClick={(event) => {
            event.preventDefault();
            event.stopPropagation();
            changeTab(2);
          }}
        >{t('client_forgotPassword')}?</span>
      </div>
      {isActive === false && (
        <div className={'warning'}>
          <p>{t('client_accountNotActivated.title')}!</p>
          <p>
            {t('client_accountNotActivated.action_label')} <span onClick={(event) => handleClick(event, email)}>
              {t('client_accountNotActivated.action_link')}
              </span>
          </p>
        </div>
      )}
      <div>
        <RenderButton type={'submit'} className={'fill'} label={t('btn_login')} disabled={isActive === false} />
      </div>
    </form>
  );
};

export default reduxForm({
  form:         'AuthForm',
  validate:     (values) => {
    // const {t}    = useTranslation();

    const errors = {};

    if (!values.login) {
      errors.login = i18n.t('client_set_email_login_phone');
    }

    if (!values.password) {
      errors.password = i18n.t('client_set_password');
    }

    return errors;
  },
  onSubmitFail: (errors, dispatch) => {
  },
})(AuthForm);